import React from 'react';
import styled from 'styled-components';

export interface DaysCarouselItemProps {
  key: number;
  dayName: string;
  dayNumber: string;
  active: boolean;
  className?: string;
  onClick?: () => void;
}

export const DaysCarouselItem: React.FC<DaysCarouselItemProps> = ({
  dayName,
  dayNumber,
  active,
  className,
  onClick,
}) => {
  return (
    <Container active={active} className={className} onClick={onClick}>
      <StyledNumber>{dayNumber}</StyledNumber>
      <StyledName>{dayName}</StyledName>
    </Container>
  );
};

interface ContainerProps {
  active: boolean;
}

const Container = styled.div<ContainerProps>`
  cursor: pointer;
  display: flex;
  width: 52px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: ${({ theme, active }) => (active ? theme.colors.blue : theme.colors.white)};
  border-radius: 8px;
  color: ${({ theme, active }) => (active ? theme.colors.white : theme.colors.dark)};
  border: 1px solid
    ${({ active, theme }) => (active ? theme.colors.blue : 'rgba(155, 155, 155, 0.32)')};
  margin-bottom: 1px;
`;

const StyledNumber = styled.div`
  font-family: 'Baloo 2';
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
`;

const StyledName = styled.div`
  font-family: 'Baloo 2';
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-transform: capitalize;
`;
